import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import z from 'zod';

const workInstructionProcessCellAttrsSchema = cellCfgAttrsBaseSchema.extend({
    processId: z.string(),
    processName: z.string(),
});

export const workInstructionProcessCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('workInstructionProcess'),
    attrs: workInstructionProcessCellAttrsSchema,
});
